import { Storage } from '@intelipost-js/secure-providers';

export default {
  filter: Object.assign({
    dateType: 'user',
    dayRange: {
      label: 'Último dia',
      value: 'LAST_DAY',
      day: 1,
    },
    warehousesIds: [],
  }, Storage.get('dashboardFilters')),
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/store/states.js